module.exports = __webpack_public_path__ + "img/bus-blue.2b1498a3.svg";